export default {
   changePriceVATRate(priceBrutto: number, oldPriceVATRate: number, newPriceVATRate: number): number {
      return Math.round(Math.round(priceBrutto * (1 - oldPriceVATRate)) / (1 - newPriceVATRate));
   },

   getPriceExcludingVAT(price: number, vat: number) {
      return Math.round(price / (vat + 1));
   }
};